import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import {
  resourcesSalidasConfigs,
  getSalidasFilters,
} from "../../helpers/backend_helper";
import { getStorageCompany } from "../../helpers/api_helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import NibbleInput from "../../components/Fields/NibbleInput";
import dayjs from "dayjs";

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
  filtersData,
  setFiltersData,
  realodData,
}) => {
  const company = getStorageCompany();
  const [errors, setErrors] = useState([]);
  const days = [
    { value: "lunes", name: "Lunes" },
    { value: "martes", name: "Martes" },
    { value: "miercoles", name: "Miércoles" },
    { value: "jueves", name: "Jueves" },
    { value: "viernes", name: "Viernes" },
    { value: "sabado", name: "Sábado" },
    { value: "domingo", name: "Domingo" },
  ];
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    route_id: null,
    select: true,
  });
  let params = { params: filters };
  const [selects, setSelects] = useState({
    ramales: [],
    operators: [],
    routes: [],
    units: [],
    timers: [
      { label: "Tiempo 1", value: 1 },
      { label: "Tiempo 2", value: 2 },
      { label: "Tiempo 3", value: 3 },
      { label: "Tiempo 4", value: 4 },
      { label: "Tiempo 5", value: 5 },
      { label: "Tiempo 6", value: 6 },
      { label: "Tiempo 7", value: 7 },
      { label: "Tiempo 8", value: 8 },
      { label: "Tiempo 9", value: 9 },
    ],
  });
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
    setItem({
      ...item,
      id: null,
      ramal_id: null,
      timer: "",
      type: "",
      operator_id: null,
      unit_id: null,
      destination: "",
      ruta_id: null,
      time_start: "",
      time_end: "",
      frequency: null,
      repeat: false,
      daysOfWeek: {
        lunes: false,
        martes: false,
        miercoles: false,
        jueves: false,
        viernes: false,
        sabado: false,
        domingo: false,
      },
    });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object({
      ramal_id: Yup.string().nullable(true).required("Requerido"),
      unit_id: Yup.string().nullable(true).required("Requerido"),
      timer: Yup.string().nullable(true).required("Requerido"),
      type: Yup.string().nullable(true).required("Requerido"),
      operator_id: Yup.string().nullable(true),
      repeat: Yup.bool(),
      destination: Yup.string().nullable(true),
      time_start: Yup.string().nullable(true).required("Requerido"),
      time_end: Yup.string().when("repeat", {
        is: true,
        then: Yup.string()
          .required("Requerido")
          .test(
            "is-greater",
            "Debe ser mayor que la hora de inicio",
            function (timeEnd) {
              const timeStart = this.resolve(Yup.ref("time_start"));
              if (!timeStart || !timeEnd) return true;

              const startDate = dayjs().format("YYYY-MM-DD") + " " + timeStart;
              const endDate = dayjs().format("YYYY-MM-DD") + " " + timeEnd;

              return dayjs(endDate).isAfter(dayjs(startDate));
            }
          ),
        otherwise: Yup.string().nullable(true),
      }),
      frequency: Yup.number().when("repeat", {
        is: true,
        then: Yup.number()
          .required("Requerido")
          .positive("Debe ser mayor que 0"),
        otherwise: Yup.number().nullable(true),
      }),
      daysOfWeek: Yup.object().test(
        "alMenosUnDia",
        "Selecciona al menos un día de la semana",
        (values) => {
          return Object.values(values).some((value) => value);
        }
      ),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      await save(values);
    },
  });

  useEffect(() => {
    const getSelects = async () => {
      const response = await getSalidasFilters();

      setSelects({
        ...selects,
        operators: response.operators,
        ramales: response.branches,
        units: response.units,
      });
    };
    getSelects();
  }, []);

  useEffect(() => {
    if(!modal.update && validation?.values?.ramal_id) {
      console.log(validation?.values?.ramal_id)
      console.log(selects.ramales.find((r) => r.id == validation?.values?.ramal_id))
      validation.setFieldValue("destination", selects.ramales.find((r) => r.id == validation?.values?.ramal_id)?.name );
    }
  }, [validation?.values?.ramal_id]);

  const save = (values) => {
    setErrors([]);

    const data = {
      ...values,
      ...values.daysOfWeek,
    };

    setLoading(true);
    if (modal.update) {
      resourcesSalidasConfigs("put", data, data.id).then((response) => {
        responseAction(response);
      });
    } else {
      resourcesSalidasConfigs("post", data).then((response) => {
        responseAction(response);
      });
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      realodData && realodData();
      handleClose();
    }
    setLoading(false);
  };

  return (
    <div>
      <Modal isOpen={modal.show} className="modal-dialog modal-lg">
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar configuración" : "Nueva configuración"}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <div className={"col-sm-12"}>
                {days.map((day) => (
                  <FormGroup
                    check
                    inline
                    key={day.value}
                    className="is-invalid"
                  >
                    <Input
                      id={day.value}
                      name={`daysOfWeek.${day.value}`}
                      type="checkbox"
                      onChange={() =>
                        validation.setFieldValue(
                          `daysOfWeek.${day.value}`,
                          !validation.values.daysOfWeek[day.value]
                        )
                      }
                      checked={validation.values.daysOfWeek[day.value]}
                      invalid={
                        validation.touched["daysOfWeek"] &&
                        validation.errors["daysOfWeek"]
                      }
                    />
                    <Label check for={day.value}>
                      {day.name}
                    </Label>
                  </FormGroup>
                ))}
                <FormFeedback type="invalid">
                  {validation.errors["daysOfWeek"]}
                </FormFeedback>
              </div>
              {authUser.profile_id == 2 && (
                <NibbleInput
                  md={4}
                  label="Unidad / Camión:"
                  fieldName="route_id"
                  fieldType="select"
                  selectItems={selects.routes}
                  validation={validation}
                />
              )}
              <NibbleInput
                md={4}
                label="Ramal:"
                fieldName="ramal_id"
                fieldType="select"
                selectItems={selects.ramales}
                validation={validation}
              />
              <NibbleInput
                md={4}
                label="¿Qué tiempo?:"
                fieldName="timer"
                fieldType="select"
                selectItems={selects.timers}
                validation={validation}
                selectOptionLabel={(e) => e.label}
                selectOptionValue={(e) => e.value}
              />

              <NibbleInput
                md={4}
                label="Tipo de salida:"
                fieldName="type"
                fieldType="select"
                selectItems={[
                  { label: "Completa", value: 1 },
                  { label: "Solo Ida", value: 2 },
                  { label: "Solo Regreso", value: 3 },
                ]}
                validation={validation}
                selectOptionLabel={(e) => e.label}
                selectOptionValue={(e) => e.value}
              />

              <NibbleInput
                md={4}
                label="Operador:"
                fieldName="operator_id"
                fieldType="select"
                selectItems={selects.operators}
                selectOptionLabel={(option) =>
                  `${option.full_name} - unidad ${option.unit?.number}`
                }
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="Unidad / Camión:"
                fieldName="unit_id"
                fieldType="select"
                selectItems={selects.units}
                selectOptionLabel={ (option) => `${option.number}` }
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="Destino:"
                fieldName="destination"
                fieldType="text"
                validation={validation}
              />
            </div>
            <div className="row">
              <NibbleInput
                md={4}
                label="Hora:"
                fieldName="time_start"
                fieldType="time"
                validation={validation}
              />

              <div className={"col-sm-2"}>
                <Form>
                  <FormGroup check inline>
                    <br />
                    <Input
                      id="repeat"
                      name="repeat"
                      type="checkbox"
                      onChange={(e) => {
                        validation.setFieldValue(
                          "repeat",
                          !validation.values.repeat
                        );
                        validation.setFieldValue("frequency", 0);
                        validation.setFieldValue("time_end", "");
                      }}
                      checked={validation.values.repeat}
                    />
                    <Label for="repeat" check>
                      ¿Repetir?
                    </Label>
                  </FormGroup>
                  <br />
                  <br />
                </Form>
              </div>

              <NibbleInput
                md={3}
                label="Frecuencia (Minutos):"
                fieldName="frequency"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={3}
                label="Hora final:"
                fieldName="time_end"
                fieldType="time"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              {" "}
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
